import { useLocation } from 'preact-iso';
import { usePodcastsStore } from '../../global-state/podcasts';
import { useUserDataStore } from '../../global-state/user-data';
import { Episode } from '../../models/podcasts';
import getThumbUrl from '../../utils/get-thumb';
import { trackLatestPodcastsClick } from '../../utils/plausible-events';
import style from './style.module.scss';

export default function LatestPodcasts() {
  const { followedPodcastIds, podcastsLastViewedEpisodeDate, recentEpisodeIds } =
    useUserDataStore();
  const podcasts = usePodcastsStore((store) => store.podcasts);
  const followedPodcasts = followedPodcastIds.map((id) => podcasts[id]).filter(Boolean);
  const { route } = useLocation();

  // Kind of a crude way of knowing that we're in a loading state, but it works...
  const showSkeleton = !followedPodcasts.length;
  if (showSkeleton) {
    return (
      <>
        <h2 class="mb-0">Latest Podcasts</h2>
        <div class={style.podcastRow}>
          <div class={style.podcastCard}>
            <img style={{ backgroundColor: '#e7e7e7' }} />
          </div>
          <div class={style.podcastCard}>
            <img style={{ backgroundColor: '#e7e7e7' }} />
          </div>
          <div class={style.podcastCard}>
            <img style={{ backgroundColor: '#e7e7e7' }} />
          </div>
        </div>
      </>
    );
  }

  const latestPodcastsData = followedPodcasts
    .map((podcast) => {
      const { id, episodes } = podcast;
      // Get new episodes that haven't been viewed by user yet
      const viewedTimestamp = podcastsLastViewedEpisodeDate[id];
      let unviewedEpisodes: Episode[] = [];
      if (viewedTimestamp) {
        const latestViewedEpisodeIndex = episodes.findIndex(
          (ep) => ep.pubDate.getTime() <= viewedTimestamp
        );
        if (latestViewedEpisodeIndex !== -1) {
          unviewedEpisodes = episodes.slice(0, latestViewedEpisodeIndex);
        }
      }
      let lastPlayedRank = recentEpisodeIds
        .slice(0, 100)
        .findIndex((compoundId) => compoundId.split('|')[0] === id.toString());
      if (lastPlayedRank === -1) lastPlayedRank = 100;

      return {
        podcast,
        lastPlayedRank,
        unviewedEpisodeCount: unviewedEpisodes.length,
      };
    })
    .sort((a, b) => {
      if (a.unviewedEpisodeCount && !b.unviewedEpisodeCount) return -1;
      return a.lastPlayedRank < b.lastPlayedRank ? -1 : 1;
    });

  return (
    <>
      <h2 class="mb-0">Latest Podcasts</h2>
      <div class={style.podcastRow}>
        {latestPodcastsData.map(({ podcast, unviewedEpisodeCount }, index) => {
          return (
            <div
              class={style.podcastCard}
              onClick={() => {
                route(`/podcast/${podcast.id}`);
                trackLatestPodcastsClick(podcast, index, unviewedEpisodeCount);
              }}
            >
              <img src={getThumbUrl(podcast, 150)} alt={podcast.name} />
              {unviewedEpisodeCount ? <span>{unviewedEpisodeCount}</span> : ''}
            </div>
          );
        })}
      </div>
    </>
  );
}
